export const LAZY_LOAD_SCROLL_TYPES = [
    'CITY',
    'ZIP',
    'DRUG',
    'PHARMACYNAME',
    'PRESCRIBERNAME',
    'GROUPNUMBER',
    'DISTRIBUTOR',
    'WHOLESALER'
];

export const createInitialScrollFlags = () => ({
    CITY: true,
    ZIP: true,
    DRUG: true,
    PHARMACYNAME: true,
    PRESCRIBERNAME: true,
    GROUPNUMBER: true,
    DISTRIBUTOR: true,
    WHOLESALER: true
});

export const mergeLazyLoadItems = (targetArr, apidata) => {
    const items = Array.isArray(apidata) ? apidata : [];
    const newArr = [...(targetArr || [])];
    let addedCount = 0;

    items.forEach((item) => {
        if (!newArr.find((e) => e.text === item.text)) {
            newArr.push(item);
            addedCount++;
        }
    });

    return { newArr, addedCount };
};

export const buildItemListJson = (items) => JSON.stringify({
    dataset: {
        ItemList: (items || []).map((item) => `"${item.text}"`)
    }
});

export const isScrollAtBottom = (element) => (
    element.scrollHeight - element.scrollTop <= element.clientHeight + 1
);

export const parseLazyLoadResponse = async (response) => {
    try {
        const text = await response.text();
        const data = text ? JSON.parse(text) : [];
        return Array.isArray(data) ? data : [];
    } catch {
        return [];
    }
};
